import React, { useEffect, useState, useCallback } from 'react';
import instance from "./axios-instance";
import Systems from "./SystemFunction";
import Swal from 'sweetalert2';
import { isMobile } from 'react-device-detect';

export default function Navbar({ onNavigate, loginstate, rankpic, user_id, username }) {
    const [categorylist, setCategoryList] = useState([]);

    // ดึงข้อมูลเกมทั้งหมด
    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await instance.post("/api/v1/tabgamelist", {
                    state: "777",
                    System: Systems,
                });

                if (res.data.status === 200) {
                    console.log("tabgamelist", res.data.message);
                    setCategoryList(res.data.message);
                }
            } catch (error) {
                console.error("tabgamelist error:", error);
            }
        };

        fetchData();
    }, []);


    const handleNav = useCallback(

        (to) => (e) => {
            // อนุญาต Ctrl/Cmd/Shift/Alt/Middle click ให้ browser จัดการ
            if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;
            e.preventDefault();
            console.log("5555", to)
            if (typeof onNavigate === "function") {
                onNavigate(to, e); // ✅ ใช้ onNavigate จาก props
            } else {
                // (fallback) เผื่อ parent ไม่ส่ง onNavigate มา
                window.history.pushState(null, "", to);
                window.dispatchEvent(new PopStateEvent("popstate"));
            }
        },
        [onNavigate]
    );


    // ฟังก์ชันเข้าเล่นเกม


    return (
        <>
            <div>
                <main className="container p-0">
                    <div className="p-1 text-left container-xl text-white mt-1 my5 animated animatedFadeInUp fadeInUp">
                        <div className="clearfix">
                            <div className="d-flex justify-content-between align-items-center">
                                <div>
                                    <h4 className="ps-2 mb-0 pt-1 f-22 text-title">
                                        <b>ตกปลา</b>
                                    </h4>
                                </div>
                                <div>
                                    <img role="button" alt="" className="w-icon-cr-bl-record-all" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="pt-1 pb-3 text-white w-scroll-height">
                        <div className="x-category-provider js-game-scroll-container js-game-container animated animatedFadeInUp fadeInUp">
                            <div className="-games-list-container container">
                                <nav className="nav-menu" id="navbarProvider">
                                    <ul className="nav nav-pills row animated animatedFadeInUp fadeInUp">
                                        {categorylist.map((listitem, i) => (
                                            <li
                                                key={i}
                                                id={listitem.gameid}
                                                className="col-4 col-lg-4 col-md-4 nav-item card-width -random-container -game-casino-macro-container p-1 pb-0 mb-2"
                                            >
                                                <a href="#" onClick={handleNav("/listgameall/fishing/" +  listitem.partner)}>
                                                    <div
                                                        className="x-game-list-item-macro js-game-list-toggle -big -cannot-entry -untestable example"
                                                        data-status="-cannot-entry -untestable"
                                                    >
                                                        <div className="-inner-wrapper card-width-banner">
                                                            <picture>
                                                                <img
                                                                    role="button"
                                                                    className="w-100 hover-slot hoverTextCss"
                                                                    src={listitem.imagesec}
                                                                    alt={listitem.description}
                                                                />
                                                            </picture>
                                                            <div className="-overlay d-none d-lg-block">
                                                                <div className="-overlay-inner">
                                                                    <div className="-wrapper-container">
                                                                        <button className="-btn -btn-play js-account-approve-aware">
                                                                            <i className="fas fa-play" />
                                                                            <span className="-text-btn">เข้าเล่น</span>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="-title mt-1 mb-0 text-center text-color-name-game">
                                                            {listitem.description}
                                                        </div>
                                                    </div>
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </>
    );
}
